/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDiscrepanciesResponse } from '../../models/get-discrepancies-response';
import { KeyType } from '../../models/key-type';

export interface GetDiscrepanciesForDeliveryNoteConsignor$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function getDiscrepanciesForDeliveryNoteConsignor(http: HttpClient, rootUrl: string, params: GetDiscrepanciesForDeliveryNoteConsignor$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscrepanciesForDeliveryNoteConsignor.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDiscrepanciesResponse>;
    })
  );
}

getDiscrepanciesForDeliveryNoteConsignor.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/discrepancies';
